<script setup>
import Button from 'primevue/button'

defineProps({ selectedCount: { type: Number, required: true } })
defineEmits(['add-tag', 'send-message', 'export-csv', 'export-xlsx', 'close'])
</script>

<template>
    <div class="absolute flex items-center gap-1 px-3 py-1.5 bg-roori-blue text-white rounded-2xl shadow-sm">
        <span class="text-sm font-semibold px-2">{{ $t('contacts.bulk_selected', { count: selectedCount }) }}</span>

        <Button text size="small" icon="pi pi-tag" :label="$t('contacts.bulk_add_tag')"
            class="!text-white !text-[13px] !font-medium hover:!bg-white/20"
            @click="$emit('add-tag')" />
        <Button text size="small" icon="pi pi-send" :label="$t('contacts.bulk_message_btn')"
            class="!text-white !text-[13px] !font-medium hover:!bg-white/20"
            @click="$emit('send-message')" />
        <Button text size="small" icon="pi pi-download" label="CSV"
            class="!text-white !text-[13px] !font-medium hover:!bg-white/20"
            @click="$emit('export-csv')" />
        <Button text size="small" icon="pi pi-download" label="XLSX"
            class="!text-white !text-[13px] !font-medium hover:!bg-white/20"
            @click="$emit('export-xlsx')" />
        <Button text rounded icon="pi pi-times" size="small"
            class="!text-white/70 hover:!text-white hover:!bg-white/20"
            @click="$emit('close')" />
    </div>
</template>
